import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';
import { StatusIndicator } from '@getro/rombo';
import ContactsSharedPopover from './ContactsSharedPopover';

const ContactsSharedCell = ({ admin, networkSlug }) => {
  if (!admin.onboardingCompleted) return null;

  const isSharing = !!admin.shareContacts;
  const memberFirstName = admin.firstName || admin.name?.split(' ')[0] || '';

  const statusIndicator = (
    <StatusIndicator
      statusColor={isSharing ? 'success' : 'neutral.300'}
      status={isSharing ? String(admin.contactsSynced ?? 0) : 'Not sharing'}
    />
  );

  return (
    <Box sx={{ '[data-testid="text-status"]': { fontSize: '14px' } }}>
      {isSharing ? (
        statusIndicator
      ) : (
        <ContactsSharedPopover
          memberFirstName={memberFirstName}
          networkSlug={networkSlug}
          trigger={
            <Box
              sx={{
                cursor: 'help',
                display: 'inline-flex',
                '[data-testid="text-status"]': {
                  textDecoration: 'underline',
                  textDecorationStyle: 'dotted',
                  textUnderlineOffset: '2px',
                },
              }}
              data-testid="not-sharing-popover-trigger"
            >
              {statusIndicator}
            </Box>
          }
        />
      )}
    </Box>
  );
};

ContactsSharedCell.propTypes = {
  admin: PropTypes.shape({
    onboardingCompleted: PropTypes.bool,
    firstName: PropTypes.string,
    name: PropTypes.string,
    shareContacts: PropTypes.bool,
    contactsSynced: PropTypes.number,
  }).isRequired,
  networkSlug: PropTypes.string.isRequired,
};

export default ContactsSharedCell;
